module.exports = __webpack_public_path__ + "img/kong.dc32ede4.svg";